import React from 'react';

type DevelopmentEnvironmentAlertProps = {};

export const DevelopmentEnvironmentAlert: React.FunctionComponent<DevelopmentEnvironmentAlertProps> = ({}): JSX.Element => {
    return (
        <div className="container" id="development-environment-alert">
            <div className="row">
                <div className="col-12">
                    <div className="alert alert-orange" style={{fontSize: '125%'}}>
                        <i className="fas fa-exclamation-triangle"/> You are currently in the Fletch <strong>Development</strong> Environment. If you are looking for production, click <a href="https://fletch.abb.com/">here</a>
                    </div>
                </div>
            </div>
        </div>
    );
}